import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import  jsPDF from 'jspdf';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {

  @ViewChild('contentToCapture') contentToCapture: ElementRef;
  imageUrl: string  ='';
  pdfDoc: jsPDF;

  constructor( public dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router,
    private loader:NgxUiLoaderService) { 
      this.pdfDoc = new jsPDF();

    }

  fromHelpSupport:boolean = false;
  ngOnInit(): void {
    console.log(this.data)
    this.imageUrl = this.data;
    if(this.router.url.includes('help_support')){
      this.fromHelpSupport = true;
    }
  }
  downloadImage() {
    const image = document.getElementById("image") as HTMLImageElement;
    const url = image.src;
    const link = document.createElement("a");
    link.href = url;
    link.download = "image.jpg";
    document.body.appendChild(link);
    link.style.display = "none"; // Hide the link
    link.click();
    document.body.removeChild(link);
  }
  
  downloadImageToPdf() {

    const img = new Image();
    img.crossOrigin = 'Anonymous'; 
      img.src = this.imageUrl;
  
    img.onload = () => {
      const pdfDoc = this.pdfDoc; // Assuming you have an initialized PDF document object
  
      // Calculate centered positioning based on image and page dimensions
      const pageWidth = pdfDoc.internal.pageSize.getWidth();
      const pageHeight = pdfDoc.internal.pageSize.getHeight();
      const imgAspectRatio = img.width / img.height;
      let newWidth, newHeight;
  
      // Prioritize fitting the entire image within the page
      if (imgAspectRatio > pageWidth / pageHeight) {
        // Image is wider than the page's aspect ratio
        newWidth = pageWidth;
        newHeight = newWidth / imgAspectRatio;
      } else {
        // Image is taller or equal to the page's aspect nseratio
        newHeight = pageHeight;
        newWidth = newHeight * imgAspectRatio;
      }
  
      // Calculate horizontal and vertical centering coordinates
      const x = (pageWidth - newWidth) / 2;
      const y = (pageHeight - newHeight) / 2;
  
      // Add the centered image to the PDF
      pdfDoc.addImage(img, 'JPEG', x, y, newWidth, newHeight);
  
      // Download or save the PDF as needed
      pdfDoc.save('image.pdf'); // Download the PDF with filename 'image.pdf'
    };
  }

}
